// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.morphle-header-logo {
    height: 4vh;
    width: auto;
    margin: 0.5vh;
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 20%;
    z-index: 1;
    padding: 10px;
    background-color: #1c002e;
    border-radius: 4px;
    box-shadow: rgba(0, 0, 0, 0.2) 0 5px 5px -3px, rgba(0, 0, 0, 0.14) 0 8px 10px 1px, rgba(0, 0, 0, 0.12) 0 3px 14px 2px;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/gammaviewer/header_gammaViewer.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,qHAAqH;AACzH","sourcesContent":[".morphle-header-logo {\n    height: 4vh;\n    width: auto;\n    margin: 0.5vh;\n}\n\n.dropdown-menu {\n    position: absolute;\n    top: 100%;\n    left: 20%;\n    z-index: 1;\n    padding: 10px;\n    background-color: #1c002e;\n    border-radius: 4px;\n    box-shadow: rgba(0, 0, 0, 0.2) 0 5px 5px -3px, rgba(0, 0, 0, 0.14) 0 8px 10px 1px, rgba(0, 0, 0, 0.12) 0 3px 14px 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
